import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContClientsSection,
  TitleClients,
  ClientsGrid,
  ClientItem,
  ClientLogo,
} from './CoreBancarioClients.styles';

import CapitlaLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Capitla.png';
import GluLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Glu.svg';
import InclusivityLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Inclusivity.png';
import KluLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Klu.png';
import RapicreditLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Rapicredit.png';

import SodacapitalLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Sodacapital.png';
import FortradeLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Fortrade.png';
import AsistyaLogo from '../../assets/images/CoreBankingModulesImages/ourClients/Asistya.png';

const clients = [

  {
    id: 2,
    logo: InclusivityLogo,
    name: 'Inclusivity',
  },
  {
    id: 3,
    logo: KluLogo,
    name: 'Klu',
  },
  {
    id: 4,
    logo: GluLogo,
    name: 'Glu',
  },
  {
    id: 1,
    logo: CapitlaLogo,
    name: 'Capitla',
  },
  {
    id: 5,
    logo: RapicreditLogo,
    name: 'Rapicredit',
  },
  {
    id: 6,
    logo: SodacapitalLogo,
    name: 'Sodacapital',
  },
  {
    id: 7,
    logo: FortradeLogo,
    name: 'Fortrade',
  },
  {
    id: 8,
    logo: AsistyaLogo,
    name: 'Asistya',
  },
];

export const CoreBancarioClients = () => {
  const { t } = useTranslation();

  return (
    <ContClientsSection>
      <TitleClients>
        {t('Nuestros Clientes')}
      </TitleClients>
      <ClientsGrid>
        {clients.map((client) => (
          <ClientItem key={client.id}>
            <ClientLogo src={client.logo} alt={client.name} />
          </ClientItem>
        ))}
      </ClientsGrid>
    </ContClientsSection>
  );
};
